export default __webpack_public_path__ + "static/media/single-corded.e9ae29af.webp";